import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { Skeleton as UISkeleton } from '@beef/ui-kit';

import { SkeletonType } from './types';
import styles from './styles.pcss';

const cn = classNames.bind(styles);

export const Skeleton: FC<SkeletonType> = ({ className, size = 'm' }) => (
  <UISkeleton className={cn(`skeleton-line--${size}`, className)} />
);
